import { AddMerchantApplication, Partner, User } from '@prisma/client';

import BorderedCard from 'src/components/BorderedCard/BorderedCard';
import { Flex } from 'src/components/Flex';
import LabeledValues from 'src/components/LabelledValues';

interface AuthorServiceDetailsProps {
    application: AddMerchantApplication & {
        author: User;
        partner: Partner;
    };
}
const AuthorServiceDetails = ({ application }: AuthorServiceDetailsProps) => {
    const partnersName = `${application?.partner?.business?.legalName ?? ''}`;
    const serviceType = application?.serviceRequirements?.service?.serviceType;
    const sellersDetails = {
        name: `${application?.author?.firstName ?? ''} ${application?.author?.lastName ?? ''}`,
        email: application?.author?.email,
    };
    const isServiceApplication = application?.isServiceApplication;
    const id = application?.id;
    return (
        <Flex gap={4}>
            <BorderedCard flexDirection="column" width={'100%'}>
                <LabeledValues label="Partner Name" value={partnersName ?? ''} />
                <LabeledValues
                    label="Seller's Details"
                    value={`${sellersDetails?.name ?? ''} / ${sellersDetails?.email ?? ''}`}
                />
            </BorderedCard>
            <BorderedCard
                flexDirection="column"
                sx={{
                    justifyContent: 'center',
                }}
                width={'100%'}
            >
                <LabeledValues
                    label={`${
                        isServiceApplication ? 'Add Service Application ID' : 'Application ID'
                    }`}
                    value={id ?? ''}
                />
                <LabeledValues label="Service Type" value={serviceType ?? ''} />
            </BorderedCard>
        </Flex>
    );
};
export default AuthorServiceDetails;
